import React, { useState, useEffect, useRef } from "react";
import PrintIcon from "@mui/icons-material/Print";
import { useNavigate } from "react-router-dom";
import useFetch from "../../../../context/useFetch";
import { toast } from "react-toastify";
import { useParams } from "react-router-dom";
import moment from "jalali-moment";
import { useSetting } from "../../../../context/SettingContext";
import MuiButton from "../../../shares/MuiButton";
import ReactToPrint, { useReactToPrint } from "react-to-print";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

const AdminPrintOrderDetails = (props) => {
  const { showNumSix, reverseShowNums } = useSetting();
  const componentRef = useRef();
  const navigate = useNavigate();
  const [ordersDetail, setOrdersDetail] = useState({
    results: [],
    detail: [],
  });
  const { id } = useParams();

  const getOrderDetailsApi = useFetch({
    method: "get",
    url: `Order_Service/${id}/admin_get_order_item_detail_from_order`,
    trigger: true,
    setter: setOrdersDetail,
    // params: { admin_change_item: statusFilter },
    argFunc: (res) => {},
    errMessage: (mess) => {
      toast.error("خطایی رخ داده است", {
        position: toast.POSITION.TOP_CENTER,
      });
    },
  });

  const get_value_color = (item_row, index) => {
    if (index == 0) {
      if (item_row.admin_change_item) {
        if (item_row.size_one_num - item_row.admin_size_one_num <= 0)
          return "text-green-500";
        return "text-red-500";
      }
      return "";
    } else if (index == 1) {
      if (item_row.admin_change_item) {
        if (item_row.size_two_num - item_row.admin_size_two_num <= 0)
          return "text-green-500";
        return "text-red-500";
      }
      return "";
    } else if (index == 2) {
      if (item_row.admin_change_item) {
        if (item_row.size_three_num - item_row.admin_size_three_num <= 0)
          return "text-green-500";
        return "text-red-500";
      }
      return "";
    } else if (index == 3) {
      if (item_row.admin_change_item) {
        if (item_row.size_four_num - item_row.admin_size_four_num <= 0)
          return "text-green-500";
        return "text-red-500";
      }
      return "";
    } else if (index == 4) {
      if (item_row.admin_change_item) {
        if (item_row.size_five_num - item_row.admin_size_five_num <= 0)
          return "text-green-500";
        return "text-red-500";
      }
      return "";
    } else if (index == 5) {
      if (item_row.admin_change_item) {
        if (item_row.size_six_num - item_row.admin_size_six_num <= 0)
          return "text-green-500";
        return "text-red-500";
      }
      return "";
    }
  };

  return (
    <>
      <div className="flex justify-between items-center mx-8 mt-4 mb-4">
        <span className="text-sm">برای دانلود فایل PDF کلیک کنید.</span>
        <div className="flex">
          <ReactToPrint
            trigger={() => {
              return (
                <MuiButton
                  variant="contained"
                  color="primary"
                  text="دانلود فایل PDF"
                  size="small"
                  //    icon={<ModeEditIcon />}
                />
              );
            }}
            content={() => componentRef.current}
          />
          <div className="mr-4">
            <MuiButton
              onClick={() => navigate(-1)}
              variant="outlined"
              color="secondary"
              text="بازگشت"
              size="small"
              icon={<ArrowBackIcon />}
            />
          </div>
        </div>
      </div>

      <div
        className="printTable"
        ref={componentRef}
        style={{ direction: "rtl" }}
      >
        <div className=" bg-myblue-100 px-8 py-4 text-center">
          <span className="font-bold text-yellow-200 text-lg">
            فروشگاه زرسان
          </span>
        </div>
        {ordersDetail.detail.length <= 0 ? (
          ""
        ) : (
          <div className="flex justify-between items-center mt-4 border border-dashed mx-2 p-4">
            <span className="show-label	">
              مشتری:{" "}
              <span className="show-value	"> {ordersDetail?.detail?.name}</span>
            </span>
            <span className="show-label	">
              سند:{" "}
              <span className="show-value	">
                {" "}
                {ordersDetail?.detail?.unique_id}
              </span>
            </span>
            <span className="show-label	">
              تاریخ ثبت سفارش:{" "}
              <span className="show-value	">
                {" "}
                {moment(ordersDetail?.detail?.created_at, "YYYY/MM/DD")
                  .locale("fa")
                  .format("YYYY/MM/DD")}
              </span>
            </span>
          </div>
        )}

        <div className="panel-main-header mt-3 mr-2">
          <span>مشخصات سفارش جاری بر اساس مشتری</span>
        </div>

        {/* <div className="mt-4">
          <span className="text-sm text-myblue-100">
            {ordersDetail.results[0]?.unique_id}
          </span>
        </div> */}

        {/* <div className="mr-4">
          <span className="text-sm text-myblue-100">
            {ordersDetail.results[0]?.bangle?.show_name}/
          </span>
          <span className="text-sm text-myblue-100">
            {ordersDetail.results[0]?.bangle?.brand_name}/
          </span>
          <span className="text-sm text-myblue-100">
            {ordersDetail.results[0]?.bangle?.gender == 'woman'
              ? 'زنانه'
              : 'بچه گانه'}
            /
          </span>
          <span className="text-sm text-myblue-100">
            {ordersDetail.results[0]?.bangle?.color == 'yellow'
              ? 'زرد'
              : 'سفید'}
          </span>
        </div> */}

        <div className="printTable mr-2 ml-2">
          <div className="border rounded-md mt-4 overflow-hidden">
            <div className="flex justify-between">
              <div className="basis-1/2  text-center py-1 ">
                <span className="text-sm text-myblue-100">ردیف</span>
              </div>
              {/* <div className="basis-1/2  text-center py-1 border-r ">
              <span className="text-sm text-myblue-100">سند</span>
            </div> */}
              {/* <div className="basis-1/2  text-center py-1 border-r ">
                <span className="text-sm text-myblue-100">مشتری</span>
              </div> */}
              {/* <div className="basis-1/2  text-center py-1 border-r ">
                <span className="text-sm text-myblue-100">تاریخ ثبت سفارش</span>
              </div> */}
              <div className="basis-1/2  text-center py-1 border-r ">
                <span className="text-sm text-myblue-100">وزن</span>
              </div>
              {/* <div className="basis-1/2  text-center py-1 border-r ">
              <span className="text-sm text-myblue-100"> وضعیت </span>
            </div> */}
              <div className="basis-1/2  text-center py-1 border-r ">
                <span className="text-sm text-myblue-100">النگو</span>
              </div>
              <div className="basis-1/2  text-center py-1 border-r ">
                <span className="text-sm text-myblue-100"> برند</span>
              </div>
              <div className="basis-1/2  text-center py-1 border-r ">
                <span className="text-sm text-myblue-100"> سن</span>
              </div>
              <div className="basis-1/2  text-center py-1 border-r ">
                <span className="text-sm text-myblue-100"> رنگ</span>
              </div>

              {reverseShowNums ? (
                <>
                  {showNumSix ? (
                    <div className="basis-1/2  text-center py-1 border-r ">
                      <span className="text-sm text-myblue-100"> شش</span>
                    </div>
                  ) : null}
                  <div className="basis-1/2  text-center py-1 border-r ">
                    <span className="text-sm text-myblue-100"> پنج</span>
                  </div>
                  <div className="basis-1/2  text-center py-1 border-r ">
                    <span className="text-sm text-myblue-100"> چهار</span>
                  </div>
                  <div className="basis-1/2  text-center py-1 border-r ">
                    <span className="text-sm text-myblue-100">سه</span>
                  </div>
                  <div className="basis-1/2  text-center py-1 border-r ">
                    <span className="text-sm text-myblue-100"> دو</span>
                  </div>
                  <div className="basis-1/2  text-center py-1 border-r ">
                    <span className="text-sm text-myblue-100"> یک</span>
                  </div>
                </>
              ) : (
                <>
                  <div className="basis-1/2  text-center py-1 border-r ">
                    <span className="text-sm text-myblue-100"> یک</span>
                  </div>
                  <div className="basis-1/2  text-center py-1 border-r ">
                    <span className="text-sm text-myblue-100"> دو</span>
                  </div>
                  <div className="basis-1/2  text-center py-1 border-r ">
                    <span className="text-sm text-myblue-100">سه</span>
                  </div>
                  <div className="basis-1/2  text-center py-1 border-r ">
                    <span className="text-sm text-myblue-100"> چهار</span>
                  </div>
                  <div className="basis-1/2  text-center py-1 border-r ">
                    <span className="text-sm text-myblue-100"> پنج</span>
                  </div>
                  {showNumSix ? (
                    <div className="basis-1/2  text-center py-1 border-r ">
                      <span className="text-sm text-myblue-100"> شش</span>
                    </div>
                  ) : null}
                </>
              )}
            </div>

            {ordersDetail.results.map((item, index) => {
              return [
                <>
                  <div className="printTableTr flex justify-between">
                    <div className="basis-1/2 border-t  text-center py-1">
                      <span className="text-sm text-myblue-100">
                        {index + 1}
                      </span>
                    </div>
                    {/* <div className="basis-1/2  border-t text-center py-1 border-r ">
                    <span className="text-sm text-myblue-100">
                      {item.unique_id}
                    </span>
                  </div> */}
                    {/* <div className="basis-1/2  border-t text-center py-1 border-r ">
                      <span className="text-sm text-myblue-100">
                        {ordersDetail.detail.name}
                      </span>
                    </div> */}
                    {/* <div className="basis-1/2  border-t text-center py-1 border-r ">
                      <span className="text-sm text-myblue-100">
                        {moment(item.receive_at, 'YYYY/MM/DD')
                          .locale('fa')
                          .format('YYYY/MM/DD')}
                      </span>
                    </div> */}
                    <div className="basis-1/2  border-t text-center py-1 border-r ">
                      <span className="text-sm text-myblue-100">
                        {item.total}
                      </span>
                    </div>
                    {/* <div className="basis-1/2  border-t text-center py-1 border-r ">
                    <span className="text-sm text-myblue-100">
                      {item.factor_status}
                    </span>
                  </div> */}
                    <div className="basis-1/2  border-t text-center py-1 border-r ">
                      <span className="text-sm text-myblue-100">
                        {item.bangle.show_name}
                      </span>
                    </div>
                    <div className="basis-1/2  border-t text-center py-1 border-r ">
                      <span className="text-sm text-myblue-100">
                        {item.bangle.brand_name}
                      </span>
                    </div>
                    <div className="basis-1/2  border-t text-center py-1 border-r ">
                      <span className="text-sm text-myblue-100">
                        {item.bangle.gender == "woman" ? "زنانه" : "بچه گانه"}
                      </span>
                    </div>
                    <div className="basis-1/2  border-t text-center py-1 border-r ">
                      <span className="text-sm text-myblue-100">
                        {item.color == "زرد" ? "زرد" : "سفید"}
                      </span>
                    </div>

                    {reverseShowNums ? (
                      <>
                        {showNumSix ? (
                          <div className=" basis-1/2 border-t text-center py-1 border-r">
                            <span className={get_value_color(item, 5)}>
                              {item.admin_size_six_num}
                            </span>
                          </div>
                        ) : null}
                        <div className="basis-1/2  border-t text-center py-1 border-r ">
                          <span className={get_value_color(item, 4)}>
                            {item.admin_size_five_num}
                          </span>
                        </div>
                        <div className="basis-1/2  border-t text-center py-1 border-r ">
                          <span className={get_value_color(item, 3)}>
                            {item.admin_size_four_num}
                          </span>
                        </div>
                        <div className=" basis-1/2 border-t text-center py-1 border-r">
                          <span className={get_value_color(item, 2)}>
                            {item.admin_size_three_num}
                          </span>
                        </div>
                        <div className="basis-1/2  border-t text-center py-1 border-r ">
                          <span className={get_value_color(item, 1)}>
                            {item.admin_size_two_num}
                          </span>
                        </div>
                        <div className="basis-1/2  border-t text-center py-1 border-r ">
                          <span className={get_value_color(item, 0)}>
                            {item.admin_size_one_num}
                          </span>
                        </div>
                      </>
                    ) : (
                      <>
                        <div className="basis-1/2  border-t text-center py-1 border-r ">
                          <span className={get_value_color(item, 0)}>
                            {item.admin_size_one_num}
                          </span>
                        </div>
                        <div className="basis-1/2  border-t text-center py-1 border-r ">
                          <span className={get_value_color(item, 1)}>
                            {item.admin_size_two_num}
                          </span>
                        </div>
                        <div className=" basis-1/2 border-t text-center py-1 border-r">
                          <span className={get_value_color(item, 2)}>
                            {item.admin_size_three_num}
                          </span>
                        </div>
                        <div className="basis-1/2  border-t text-center py-1 border-r ">
                          <span className={get_value_color(item, 3)}>
                            {item.admin_size_four_num}
                          </span>
                        </div>
                        <div className="basis-1/2  border-t text-center py-1 border-r ">
                          <span className={get_value_color(item, 4)}>
                            {item.admin_size_five_num}
                          </span>
                        </div>
                        {showNumSix ? (
                          <div className=" basis-1/2 border-t text-center py-1 border-r">
                            <span className={get_value_color(item, 5)}>
                              {item.admin_size_six_num}
                            </span>
                          </div>
                        ) : null}
                      </>
                    )}
                  </div>
                </>,
              ];
            })}
          </div>
        </div>
      </div>
    </>
  );
};

export default AdminPrintOrderDetails;
